export default {
    icon: "el-icon-download",
    title: "辅助线",
    name: "guide",
    timestamp: 1706343486906001,
    lineColor: {
        title: "线条颜色",
        default: [
            {
                item: "#f5f5f5"
            }
        ],
        color: [
            {
                item: "#333"
            }
        ]
    },
    lineStyle: {
        title: "线条样式",
        type: 1,
        list: [
            {
                val: "虚线",
                style: "dashed",
                icon: "el-icon-more"
            },
            {
                val: "实线",
                style: "solid",
                icon: "el-icon-minus"
            },
            {
                val: "点状线",
                style: "dotted",
                icon:"el-icon-more-outline"
            }
        ]
    },
    heightConfig: {
        title: "组件高度",
        val: 1,
        min: 1
    },
    lrEdge: {
        title: "左右边距",
        val: 0,
        min: 0
    },
    mbConfig: {
        title: "页面间距",
        val: 0,
        min: 0
    },
    id: "id1706343466365000"
}